import { Context, useContext } from 'react';
import * as React from 'react';

export type PortalLinkContextProps = {
  isRouteLinksEnabled: boolean;
  onLegacyNavigate?: (navigationProps: unknown) => void;
};

export const PortalLinkContext: Context<PortalLinkContextProps> =
  React.createContext({ isRouteLinksEnabled: false } as PortalLinkContextProps);

export const usePortalLinkContext = (): PortalLinkContextProps => {
  return useContext<PortalLinkContextProps>(PortalLinkContext);
};
